import { render, staticRenderFns } from "./EditUserRealms.vue?vue&type=template&id=358642d7&scoped=true&"
import script from "./EditUserRealms.vue?vue&type=script&lang=ts&"
export * from "./EditUserRealms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358642d7",
  null
  
)

export default component.exports